import { tokens } from '@welbe/web-design-system';
import styled, { css } from 'styled-components';

export const Container = styled.div`
	width: 100%;

	textArea {
		background-color: ${tokens.color_gray_light};
	}
`;

export const Subtitle = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;

	padding-bottom: 40px;
`;

export const TableContainer = styled.table`
	color: ${tokens.color_gray_dark};
	font-size: 14px;
	font-weight: 500;
	width: 100%;

	tr > td {
		padding-bottom: 10px;
	}

	& th {
		background-color: ${tokens.color_gray_light};
		padding: 10px;
		text-align: left;
		color: ${tokens.color_primary};
		font-size: 14px;
	}

	& td {
		font-size: 14px;
	}
`;

export const TdName = styled.td`
	width: 40vw;
	p {
		max-width: 40vw;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;

export const TdType = styled.td`
	width: 15vw;
	li {
		padding-left: 10px;
		max-width: 15vw;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		list-style: none;
		display: flex;
		align-content: center;
		::before {
			content: '●';
			font-size: 12px;
			padding-right: 5px;
			align-self: center;
		}
	}
`;

export const TdFrequency = styled.td`
	width: 10vw;
	padding-left: 10px;
	max-width: 10vw;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const ButtonContainer = styled.div`
	width: 100%;
	display: flex;
	gap: 30px;
	justify-content: center;
	padding-top: 30px;
	svg {
		padding-left: 10px;
	}
`;

export const ExposureContainer = styled.div`
	gap: 10px;

	li {
		list-style: none;
		::before {
			content: '●';
			font-size: 8px;
			padding-right: 5px;
			align-self: center;
		}
	}
`;

export const Banner = styled.div`
	border-radius: 10px;
	background-color: ${tokens.color_gray_light};
	padding: 30px;
	height: 442px;

	margin-bottom: 30px;
`;

export const Title = styled.div`
	display: grid;
	grid-template-columns: 55px 1fr;
	gap: 20px;
	grid-gap: 20px;
`;

export const Benefits = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 26px;
	grid-gap: 26px;
`;

export const BenefitItem = styled.div`
	display: grid;
	grid-template-columns: 55px 1fr;
	gap: 16px;
	grid-gap: 16px;
`;

export const InfoContainer = styled.div`
	margin-top: 30px;
	height: 242px;
`;

export const MoreInfo = styled.div`
	display: grid;
	place-content: center;
`;

export const FileContainer = styled.div<{ hasFile: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;

	svg {
		cursor: pointer;
	}

	${({ hasFile }) =>
		!hasFile &&
		css`
			svg {
				cursor: not-allowed;
				path {
					fill: ${tokens.color_gray_medium};
				}
			}
		`}
`;
